import { buildURI } from '.';

import accessToken from 'utils/accessToken';

function login(username: string, password: string) {
  return fetch(
    buildURI('/login'),
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    },
  );
}

function logout() {
  return fetch(
    buildURI('/logout'),
    {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: {
        'Grpc-Metadata-auth-token': accessToken.get() as string,
      },
    },
  );
}

// refreshTokens will use the access_token cookie
function refreshTokens() {
  return fetch(
    buildURI('/refresh-token'),
    {
      method: 'POST',
      credentials: 'same-origin',
    },
  );
}

export default {
  login,
  logout,
  refreshTokens,
};
